<template>
  <div class="moow-master-container play-background">
     <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      loading: true
    };
  },
  computed: {},
  created() {},
  updated() {},
  methods: {
    
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

</style>



// WEBPACK FOOTER //
// src/components/utils/FullLoader.vue